import Button from '@mui/material/Button';
import { GridToolbarContainer } from '@mui/x-data-grid';
import { EditToolbarProps } from '../type';
import { useMutation } from '@apollo/client';
import { EDIT_MEMBERS_MUTATION } from '../gql';

function EditToolbar({
  rows,
  setRows,
  originalRows,
  setOriginalRows,
  selections,
  setSelections
}: EditToolbarProps): JSX.Element | null {
  const [editMembers] = useMutation(EDIT_MEMBERS_MUTATION);
  const handleDiscardClick = (): void => {
    setRows(originalRows);
    setSelections({});
  };

  const handleSaveClick = async (): Promise<void> => {
    setRows(rows.map((row) => ({ ...row, edit: false })));
    setOriginalRows(rows.map((row) => ({ ...row, edit: false })));
    const input = Object.keys(selections).map((key) => ({
      id: key,
      departmentIds: selections[key].departments,
      memberRoleIds: selections[key].roles
    }));
    try {
      await editMembers({ variables: { input } });
    } catch (error) {
      console.error('Error executing mutation:', error);
    }
    setSelections({});
  };

  if (rows.some((row) => row.edit)) {
    return (
      <GridToolbarContainer
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '16px',
          padding: '10px'
        }}
      >
        <Button
          onClick={handleDiscardClick}
          sx={{ textTransform: 'none', borderRadius: '20px' }}
        >
          Discard All
        </Button>
        <Button
          variant="outlined"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={handleSaveClick}
          sx={{ textTransform: 'none', borderRadius: '20px' }}
        >
          Save All
        </Button>
      </GridToolbarContainer>
    );
  }

  return null;
}

export default EditToolbar;
